<template>
  <div class="report_index">
    <div class="report_title">
      <el-icon class="el-icon-edit-outline"></el-icon> 理赔报案
    </div>
    <div class="report_form">
      <div class="report_form_one">
        <div class="report_form_title">
          船舶名称 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          <el-input size="small" placeholder="请输入船舶名称" v-model="form.shipname"></el-input>
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          保单号 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          <el-input size="small" placeholder="请输入保单号" v-model="form.policy_number"></el-input>
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          出险地点 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          <el-input size="small" placeholder="请输入出险地点" v-model="form.report_address"></el-input>
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          出险日期 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          <el-date-picker
            v-model="form.report_datetime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期时间">
          </el-date-picker>
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          图片上传
        </div>
        <div class="report_form_input">
          <el-upload
            name="files"
            :action="domain+`/file/upload`"
            :multiple="true"
            :before-upload="beforeUploadImg"
            :on-error="errorUpload"
            :on-success="successUploadImg"
            :with-credentials="true"
            :show-file-list="false"
            :file-list="imgList">
            <el-button size="small" style="width:100%;">上传现场图片<el-icon class="el-icon-upload2"></el-icon></el-button>
          </el-upload>
        </div>
      </div>
      <div class="report_media_box" v-if="imgPre.length>0">
        <div class="report_media_one" v-for="(img,index) in imgPre" :key="index">
          <el-image :src="img" :preview-src-list="imgPre"/>
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          视频上传
        </div>
        <div class="report_form_input">
          <el-upload
            name="files"
            :action="domain+`/file/upload`"
            :multiple="true"
            :before-upload="beforeUploadVideo"
            :on-error="errorUpload"
            :on-success="successUploadVideo"
            :with-credentials="true"
            :show-file-list="false"
            :file-list="videoList">
            <el-button size="small" style="width:100%;">上传现场视频<el-icon class="el-icon-upload2"></el-icon></el-button>
          </el-upload>
        </div>
      </div>
      <div class="report_media_box" v-if="videoPre.length>0">
        <div class="report_media_one" v-for="(video,index) in videoPre" :key="index">
          <el-image :src="video"/>
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          手机号 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          <el-input size="small" placeholder="请输入手机号" v-model="form.phone"></el-input>
        </div>
      </div>
      <div class="report_form_one">
        <div class="report_form_title">
          出险经过 <span style="color:red;font-size:.7rem;">*</span>
        </div>
        <div class="report_form_input">
          <el-input type="textarea" placeholder="请描述出险经过" v-model="form.report_detail"></el-input>
        </div>
      </div>
    </div>
    <div class="report_bottom">
      <el-button type="primary" style="width:90%;margin:0 5%;" @click="submit">提交报案</el-button>
    </div>
  </div>
</template>

<script>
  import { getDomain,reportAdd } from '../../api/api'
  import { getBrowserType } from '../../util/common'

  export default {
    name: "ReportAdd",
    data() {
      return {
        domain:getDomain(),
        imgList:[],
        imgPre:[],
        videoList:[],
        videoPre:[],
        form:{
          shipname:'',
          policy_number:'',
          report_address:'',
          report_datetime:new Date().valueOf(),
          phone:'',
          report_detail:''
        },
        maxsize:1024*1024*10
      }
    },
    mounted() {

    },
    methods: {
      beforeUploadImg(e){
        if(e.type.indexOf('image')===-1){
          this.$message.warning('文件格式错误:'+e.name);
          return false;
        }
        if(e.size > this.maxsize){
          this.$message.warning('文件超过:10MB');
          return false;
        }
        return true;
      },
      beforeUploadVideo(e){
        if(e.type.indexOf('video')===-1 && e.type.indexOf('audio')===-1){
          this.$message.warning('文件格式错误:'+e.name);
          return false;
        }
        if(e.size > this.maxsize){
          this.$message.warning('文件超过:10MB');
          return false;
        }
        return true;
      },
      errorUpload(e){
        this.$message.success('上传失败:'+e);
      },
      successUploadImg(e){
        if(e.status === 403){
          if(getBrowserType()===1){
            this.$wx.miniProgram.redirectTo({url: '/pages/login/login'})
          }else{
            this.$router.push('/index/login');
          }
        }else if(e.status === 0){
          this.imgPre.push(e.data[0]['path']);
          this.$message.success('上传成功');
        }else{
          this.$message.error(e.message);
        }
      },
      successUploadVideo(e){
        if(e.status === 403){
          if(getBrowserType()===1){
            this.$wx.miniProgram.redirectTo({url: '/pages/login/login'})
          }else{
            this.$router.push('/index/login');
          }
        }else if(e.status === 0){
          this.videoPre.push(e.data[0]['path']);
          this.$message.success('上传成功');
        }else{
          this.$message.error(e.message);
        }
      },
      submit(){
        let params = JSON.parse(JSON.stringify(this.form));
        if(!params['shipname']){
          this.$message.warning('请输入船舶名称');
          return;
        }
        if(!params['policy_number']){
          this.$message.warning('请输入保单号');
          return;
        }
        if(!params['report_address']){
          this.$message.warning('请输入出险地点');
          return;
        }
        if(!params['report_datetime']){
          this.$message.warning('请选择出险时间');
          return;
        }
        if(!params['phone']){
          this.$message.warning('请输入手机号');
          return;
        }
        if(!params['report_detail']){
          this.$message.warning('请填写出险经过详情');
          return;
        }
        params['img_list'] = JSON.parse(JSON.stringify(this.imgPre));
        params['video_list'] = JSON.parse(JSON.stringify(this.videoPre));
        params['report_datetime'] = parseInt(params['report_datetime']/1000);
        reportAdd(params).then(res => {
          if(res && res.status === 0){
            this.$message.success('提交成功');
            this.$router.push('/report/index');
          }
        });
      }
    }
  }
</script>

<style scoped>
  .report_index {
    top: 6vh;
    left: 0;
    position: absolute;
    height: 94vh;
    width: 100%;
    margin: 0;
    background-color: #eee;
    overflow-y: scroll;
  }
  .report_title {
    height:2rem;
    line-height:2rem;
    text-indent: .5rem;
    font-size:.95rem;
    color:#03a7d5;
  }
  .report_bottom {
    width:100%;
    position:absolute;
    bottom:0;
    height:4.8rem;
    line-height:4.8rem;
    border-top:1px #ddd dashed;
  }
  .report_form {
    height:80vh;
    overflow-y: scroll;
  }
  .report_form_one {
    height:2.7rem;
    line-height:2.7rem;
    width:90%;
    margin:.5rem 5%;
  }
  .report_form_title {
    width:20%;
    float:left;
    font-size:.8rem;
    color:#666;
    height:2.7rem;
    line-height:3rem;
  }
  .report_form_input {
    margin-left:3%;
    width:75%;
    float:left;
    height:2.7rem;
    line-height:2.7rem;
  }
  .report_media_box {
    width:100%;
    height:4rem;
    overflow:hidden;
  }
  .report_media_one {
    height:3rem;
    width:20%;
    margin:.5rem 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/add.vue